import { useState } from "react";
import { createContext } from "react";
export const CommentContext = createContext();
